import { Guid } from "@/Common/Models/Guid";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";
import { IServicePublishingConfig } from "./IServicePublishingConfig";

interface IComboOrServiceItem {
    Name: string;
    NameLookupId: string;
}

abstract class BaseServiceComboDefinitionModel implements IComboOrServiceItem {
    public NameFR: string;
    public NameEN: string;
    public NameES: string;

    public OnlineNameFR: string;
    public OnlineNameEN: string;
    public OnlineNameES: string;
    public OnlineDescriptionEN: string;
    public OnlineDescriptionFR: string;
    public OnlineDescriptionES: string;
    public OnlineDisclaimerEN: string;
    public OnlineDisclaimerFR: string;
    public OnlineDisclaimerES: string;

    public Name: string;
    public NameLookupId: string;
    public OnlineGroupId: string;
    public OnlineNameLookupId: string;
    public OnlineDescriptionLookupId: string;
    public OnlineDisclaimerLookupId: string;

    public NotificationConfigurationId: string;

    public Duration: number;

    public IsAdHoc: boolean;

    public abstract SetIsNotifyPatientDisabledByDefault(val: boolean): void;
    public abstract GetIsNotifyPatientDisabledByDefault(): boolean;

    public abstract Clone(deepClone: boolean): BaseServiceComboDefinitionModel;

    public abstract SetUrgency(val: boolean): void;
    public abstract GetUrgency(): boolean;

    public abstract SetOnlineAvailability(val: boolean): void;
    public abstract GetOnlineAvailability(): boolean;

    public abstract SetOnlineClienenteleCible(val: ServiceComboTargetClientele): void;
    public abstract GetOnlineClienenteleCible(): ServiceComboTargetClientele;

    public abstract SetPublishingConfig(val: IServicePublishingConfig): void;
    public abstract GetPublishingConfig(): IServicePublishingConfig;

    public abstract SetSiteId(val: Guid): void;
    public abstract GetSiteId(): Guid;

    public abstract SetSpecializationId(val: string): void;
    public abstract GetSpecializationId(): string;

    public abstract SetPrice(val: number): void;
    public abstract GetPrice(): number;

    public abstract GetDefaultDurationMinutes(): number;
    public abstract InitLookup(): void;

    public abstract SetIsTeleconsultation(val: boolean): void;
    public abstract GetIsTeleconsultation(): boolean;

    public abstract SetQuestionnaireId(val: string): void;
    public abstract GetQuestionnaireId(): string;
}

export { BaseServiceComboDefinitionModel, IComboOrServiceItem };
